<template>
    <div>
        <li class="m_li m_tops" @mouseleave="onMouseOut($event)" @mouseenter="onMouseOver($event)">
            <a href="javascript:;" @click="toTop" class="f f20">
                <i class="iconfont icon-icon"></i>
            </a>
            <p class="r_av m_tr" :style="active">返回顶部<em class="r_vt">◆</em></p>
        </li>
    </div>
</template>

<script>
export default{
    data(){
        return{
            active:"",
            gotop: false
        }
    },
    mounted() {
        // 此处true需要加上，不加滚动事件可能绑定不成功
        window.addEventListener("scroll", this.handleScroll, true);
    },
    methods:{
        handleScroll() {
            let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
            scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
        },
        toTop(){
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            // 实现滚动效果 
            const timeTop = setInterval(() => {
                document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
                if (top <= 0) {
                clearInterval(timeTop);
                }
            }, 10);
        },
        onMouseOver($event){
            $event.currentTarget.className="m_li m_lion";
            this.active="opacity: 1; right: 35px; display: block;"
        },
        onMouseOut($event){
            $event.currentTarget.className="m_li";
            this.active="opacity: 0; right: 70px; display: none;"
        },
    },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/right-totop.vue